import { Button, PageHeader } from '@lmc/ui-kit'
import { scrollToTop } from '../../utils/utils'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  ProfileWrapper,
  ButtonsWrapper,
  ProfileContent,
} from '../../styledComponents'
import { useEffect, useRef, useState } from 'react'
import { Form as AntdForm } from 'antd'
import ContingencyPlanForm from './components/ContingencyPlanForm'
import NavigationModal from 'components/NavigationModal/NavigationModal'

const AddContingencyPlan = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const [form] = AntdForm.useForm()
  const navigate = useNavigate()
  const topRef = useRef<HTMLDivElement | null>(null)
  const [isDirty, setIsDirty] = useState(false)
  const [isCreateLoading, setIsCreateLoading] = useState(false)

  const handleOnCancel = () => {
    navigate(`../`, { relative: 'path' })
  }

  useEffect(() => {
    scrollToTop(topRef)
  }, [])

  return (
    <ProfileWrapper ref={topRef}>
      <PageHeader sticky title={t(supConstants.CONTINGENCY_PLAN)}>
        <ButtonsWrapper>
          <Button onClick={handleOnCancel}>{t(supConstants.CANCEL)}</Button>
          <Button
            variant="primary"
            onClick={form.submit}
            type="submit"
            isLoading={isCreateLoading}
          >
            {t(supConstants.SAVE)}
          </Button>
        </ButtonsWrapper>
      </PageHeader>
      <ProfileContent>
        <NavigationModal canNavigate={!isDirty} />
        <ContingencyPlanForm
          create
          form={form}
          setIsCreateLoading={setIsCreateLoading}
          setIsDirty={setIsDirty}
        />
      </ProfileContent>
    </ProfileWrapper>
  )
}

export default AddContingencyPlan
